;
define("product_details_quickview.tpl", function(){});

